export function renderNull(text: string | undefined) {
  return text === 'None' || text === '' || text === undefined ? '-' : text
}
